import { render, staticRenderFns } from "./uploadEnquiries.vue?vue&type=template&id=24f3936f&scoped=true"
import script from "./uploadEnquiries.vue?vue&type=script&lang=js"
export * from "./uploadEnquiries.vue?vue&type=script&lang=js"
import style0 from "./uploadEnquiries.vue?vue&type=style&index=0&id=24f3936f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f3936f",
  null
  
)

export default component.exports